const attributes = {
  name: 'name',
  email: 'email',
  password: 'password',
  password_confirmation: 'password',
}

export default attributes
